import React from 'react';
import {Box, Divider, Typography, makeStyles} from '@material-ui/core';
import BaliardaLogo from '../../../content/images/logos baliarda/logo-color.png';

const useStyles = makeStyles((theme) => ({
  logo: {
    height: 'auto',
    width: 'auto',
    maxHeight: '300px',
    verticalAlign: 'middle',
  },
}));

const Welcome = ({message, subtitle}) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{minHeight: '70vh', gap: 2}}>
      <Typography variant="h4" fontWeight="600">
        {message}
      </Typography>

      <Divider flexItem style={{margin: '16px 0'}} />

      {subtitle && (
        <Typography variant="h6" color="text.secondary">
          {subtitle}
        </Typography>
      )}
      <img src={BaliardaLogo} className={classes.logo} alt="Mox It Logo" />
    </Box>
  );
};

export default Welcome;
